import { Button } from 'antd';

export const LinkButton = ({ children, open, ...props }) => (
    <Button
        type="text"
        size='large'
        children={open ? children : null}
        style={{
            width: '100%',
            justifyContent: open ? 'flex-start' : 'center',
            transition: 'all 0.3s ease-in-out',
            padding: '4px 8px'
        }}
        {...props}
    />
)